export default "__VITE_ASSET__4e3b0251__"